import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

export const convertStringArrayToSelectOption = (arr: string[]): ISelectOption<string>[] =>
  arr.filter(item => item).map(item => ({ id: item, label: item, value: item }));
